import { useState, useEffect, forwardRef } from "react";
import ReactSelect from 'react-select';
import Fetch from '../../../../../util/core/Fetch';
import Toast from "../../Toast/Toast";
import { useDispatch } from "react-redux";

const RowSelect = forwardRef((props, ref) => {
  const initialValue = { value: props.value };
  const dispatch = useDispatch();

  const [focused, setFocused] = useState(false);

  let [value, updateValue] = useState(initialValue);
  let [options, updateOptions] = useState(props.options);
  let [error, updateError] = useState(props.error);
  let [readOnly, setReadOnly] = useState(false);
  let [sort, setSort] = useState((typeof props.sort === "undefined")?'ASC':props.sort); 
  let className = '';
  let customStyle = {};

  const item = JSON.parse(props.item);
  const column = props.column;

  useEffect(() => {
    const loadOptions = async () => {
      let option = {}

      if(value && value[0]){
        value = value[0];
      }

      option = options?.filter(selected => selected.value == value?.value);
      updateValue(option);

      if (props.optionsEndpoint && props.optionsEndpoint.endpoint) {
        let url = props.optionsEndpoint.endpoint;
        let keyLabel = props.optionsEndpoint.label;
        let keyValue = props.optionsEndpoint.value;
        const params = props.optionsEndpoint.params ? props.optionsEndpoint.params : {};
        let rows = await Fetch.post(url, params);

        let tempOptions = rows.map(item => (
          {
            value: item[keyValue],
            label: item[keyLabel]
          }
        ));
        
        option = tempOptions.filter(selected => selected.value == value?.value);

        if (!option[0]?.value) { option = { value: 'N/A', label: 'N/A' }; };

        if(sort){
          tempOptions.sort((a, b) => {
            const labelA = a.label?a.label:'';
            const labelB = b.label?b.label:'';
            let fa = labelA.toLowerCase(),
            fb = labelB.toLowerCase();
            if (fa < fb) {
                return -1;
            }
            if (fa > fb) {
                return 1;
            }
            return 0;
          });

          if(sort == 'DESC'){
            tempOptions = tempOptions.reverse()
          }
        }

        updateOptions(tempOptions);
        updateValue(option);

        if (tempOptions.length === 1 && props.canAutoFill && props.required) {
          updateValue(tempOptions[0]);
          handleChange(tempOptions[0]);
          setReadOnly(true);
        }
      }
    }
    loadOptions();

  }, [props.value]);

  const handleDefaultSubmit = async (item, column, value) => {
    try {
      await Fetch.put(props.endpointSave, {
        ...item,
        [column.column]: value,
      });
      Toast.success('Informações atualizadas com sucesso.');
      dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
    } catch (e) {
      console.log(e);
      Toast.error('Erro ao atualizar informações.');
    }
  };

  const handleChange = async (element) => {
    dispatch({ type: 'SHOW_LOADING', value: true });
    const target = {
      name: props.name,
      type: 'select',
      ...element
    }
    updateValue(element);

    if (props.onChange) {
      await props.onChange(item, column, target.value);
      dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
    } else {
      await handleDefaultSubmit(item, column, target.value);
    }
    dispatch({ type: 'SHOW_LOADING', value: false });
  };

  const handleFocus = () => setFocused(true);

  const handleBlur = () => setFocused(false);

  if (props.error) {
    className = "is-invalid";
    customStyle = { border: '1px solid #dc3545' };
  } 
  
  return (
    <div ref={ref} onClick={handleFocus}>
      <div 
          style={{ ...customStyle, minWidth: props.minWidth || '200px' }}
        >
        {focused ? (
          <ReactSelect
            autoFocus={focused || !!props.autoFocus}
            isClearable={props.isClearable}
            name={props.name}
            placeholder={props.placeholder ? props.placeholder : 'Selecione'}
            options={options}
            onChange={handleChange}
            value={value}
            isDisabled={props.disabled}
            isSearchable={!readOnly}
            menuIsOpen={readOnly ? false : undefined}
            menuPortalTarget={document.body}
            menuPosition='fixed'
            onBlur={handleBlur}
          /> ) : (
            <span>{Array.isArray(value) ? value[0]?.label : (value?.label || initialValue.value)}</span>
          )}
      </div>
      {props.error && (
        <span
          className="error invalid-feedback"
          style={{ display: 'inline' }}>
          {props.error}
        </span>
      )}


    </div>
  );
})
export default RowSelect;

